import { Link } from 'gatsby';
import styled from 'styled-components';

export const SectionParent = styled.section`
  padding: 0rem 14rem;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding: 0rem 10rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding: 0rem 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 9px;
    padding-left: 2rem;
    padding-right: 2rem;
  }
  @media (max-width: 520px) {
    padding: 1rem;
  }
`;

export const H1 = styled.h1`
  margin: 0;
  padding: 0;
  font-weight: bold;
  font-size: 24px;
  line-height: normal;
  margin-bottom: 0.5rem;
  color: #151828;
  @media (max-width: 1440px) {
    font-size: 24px;
  }
  @media (max-width: 768px) {
    font-size: 22px;
  }
  @media (max-width: 520px) {
    text-align: center;
    font-size: 20px;
  }
`;
export const H2 = styled.h2`
  margin: 0;
  padding: 0;
  font-size: 18px;
  line-height: normal;
  color: #fff;
  font-family: 'Nunito Sans', sans-serif;
  @media (max-width: 1440px) {
    font-size: 18px;
  }
  @media (max-width: 768px) {
    font-size: 18px;
  }
  @media (max-width: 520px) {
    text-align: center;
    font-size: 18px;
  }
`;

export const H3 = styled.h2`
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: normal;
  color: #fff;
  font-family: 'Nunito Sans', sans-serif;
  @media (max-width: 1440px) {
    font-size: 14px;
  }
  @media (max-width: 768px) {
    font-size: 14px;
  }
  @media (max-width: 520px) {
    text-align: center;
    font-size: 14px;
  }
`;

export const H4 = styled.h4`
  margin: 0;
  padding: 0;
  font-size: 24px;
  line-height: normal;
  color: #fff;
  font-family: 'Nunito Sans', sans-serif;
  @media (max-width: 1440px) {
    font-size: 22px;
  }
  @media (max-width: 768px) {
    font-size: 18px;
  }
  @media (max-width: 520px) {
    text-align: center;
    font-size: 18px;
  }
`;

export const B1 = styled.div`
  font-size: 16px;
  @media (max-width: 1440px) {
    font-size: 16px;
  }
  @media (max-width: 768px) {
    font-size: 16px;
  }
  @media (max-width: 520px) {
    font-size: 16px;
  }
`;

export const B3 = styled.div`
  font-size: 14px;
  @media (max-width: 1440px) {
    font-size: 14px;
  }
  @media (max-width: 768px) {
    font-size: 14px;
  }
  @media (max-width: 520px) {
    font-size: 12px;
  }
`;

export const Button = styled.button`
  height: 48px;
  padding: 0rem 3rem;
  border-radius: 2px;
  cursor: pointer;
  margin: 10px;
  /* text-transform: uppercase; */
  overflow: hidden;
  border-width: 0;
  outline: none;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  color: #fff;
  font-size: 18px;
  @media (max-width: 768px) {
    font-size: 16px;
  }
  @media (max-width: 520px) {
    font-size: 16px;
    padding: 0rem 1rem;
    height: 2.5rem;
  }
  /* font-weight: 600; */
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  text-rendering: geometricprecision;
  letter-spacing: normal;
  transition: all 0.05s linear;
  :hover {
    box-shadow: 0 6px 10px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  }
  :focus {
    box-shadow: 0 6px 10px rgba(50, 50, 93, 0.3), 0 1px 3px rgba(0, 0, 0, 0.08);
    outline: none;
  }
`;
export const ButtonA = styled(Link)`
  height: 48px;
  padding: 0.55rem 3rem;
  border-radius: 2px;
  cursor: pointer;
  margin: 10px;
  /* text-transform: uppercase; */
  overflow: hidden;
  border-width: 0;
  outline: none;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  color: #fff !important;
  font-size: 18px;
  @media (max-width: 768px) {
    font-size: 16px;
  }
  @media (max-width: 520px) {
    font-size: 16px;
    padding: 0.5rem 2rem;
    height: 2.5rem;
  }
  /* font-weight: 600; */
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  text-rendering: geometricprecision;
  letter-spacing: normal;
  transition: all 0.05s linear;
  :hover {
    box-shadow: 0 6px 10px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  }
  :focus {
    box-shadow: 0 6px 10px rgba(50, 50, 93, 0.3), 0 1px 3px rgba(0, 0, 0, 0.08);
    outline: none;
  }
`;

export const BlueButton = styled(Button)`
  border-radius: 35px;
  background: linear-gradient(45deg, #725cbd, #9b6ad4);
`;

export const HollowButton = styled(Button)`
  border-radius: 35px;
  background: white;
  color: #151828;
  border: #151828;
  box-shadow: none !important;
  :hover {
    box-shadow: 0 0.5px 1px rgb(0, 0, 0), 0 1px 3px rgb(0, 0, 0) !important;
  }
  /* :active {
    box-shadow: 0 0.5px 1px rgb(0, 0, 0), 0 1px 3px rgb(0, 0, 0);
  }
  :visited {
    box-shadow: 0 0.5px 1px rgb(0, 0, 0), 0 1px 3px rgb(0, 0, 0);
  } */
  /* :focus {
    box-shadow: 0 0.5px 1px rgb(0, 0, 0), 0 1px 3px rgb(0, 0, 0);
  } */
`;

export const BlueButtonA = styled(ButtonA)`
  border-radius: 35px;
  background: linear-gradient(45deg, #725cbd, #9b6ad4);
`;

export const GeneralPageContainer = styled(SectionParent)`
  background-image: linear-gradient(to top, #6d53b4, #382f6e),
    linear-gradient(271deg, #382f6e, #6d53b4 44%, #382f6e);
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
  display: grid;
  align-items: center;
  justify-items: center;
`;

// Old components

export const ThankYouSection = styled(SectionParent)`
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
  background-position-y: bottom;
  display: grid;
  align-content: center;
  justify-items: center;
  z-index: 2;
`;

export const PrivacyPolicy = styled.h1`
  margin-top: 5rem;
  color: #fff;
  letter-spacing: -0.85px;
  font-size: 57px;
  text-align: center;
  font-weight: 500;
`;

export const PrivacyPolicyContent = styled(SectionParent)`
  margin-bottom: 5rem;
  margin-top: 3rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  text-align: justify;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: normal;
  color: #122a38;
  @media (max-width: 768px) {
    font-size: 16px;
    text-align: justify;
  }
  @media (max-width: 480px) {
    font-size: 14px;
    text-align: justify;
  }
`;

export const MainPage = styled.div`
  padding-top: 90px;
  @media (max-width: 768px) {
    padding-top: 70px;
  }
`;
